module.exports = __webpack_public_path__ + "img/online_shopping_03.d9c9ffb4.png";